import e from "./config.js";
import r from "./utils/defer.js";
import { buildQuery as o } from "./utils/url.js";
var a = r(),
    i = {
  ready: !1,
  loaded: !1
},
    d = a.promise;

function n() {
  if (!i.loaded) {
    if (i.loaded = !0, window.AMap) return a.resolve(window.AMap), d;
    var r = document.createElement("script"),
        n = "amap_react_" + Date.now() + "_" + Math.ceil(1e4 * Math.random());

    window[n] = function () {
      i.ready || (i.ready = !0, a.resolve(window.AMap));
    };

    var t = o({
      v: e.version,
      key: e.key,
      callback: n,
      plugin: e.plugins.join(",")
    }),
        l = e._prefix + "?" + t;
    r.src = l, document.body.appendChild(r);
  }

  return d;
}

export default n;
export { d as ready };